import { PagedResultDto } from '@shared/components/paged-listing-component-base';
import { SportDto } from './sport-dto';

export class SportPagedResultDto extends PagedResultDto {
  public items: SportDto[] = [];
}
